import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useEffect } from "react";

interface BookingModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const BookingModal = ({ open, onOpenChange }: BookingModalProps) => {
  useEffect(() => {
    if (open) {
      const script = document.createElement("script");
      script.src = "https://app.foundrywave.tech/js/form_embed.js";
      script.type = "text/javascript";
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">Book a Consult</DialogTitle>
          <DialogDescription>
            Schedule a time to discuss your custom solution needs.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <iframe
            src="https://app.foundrywave.tech/widget/booking/RRXx1flMrsEQKcUpH5Rb"
            style={{ width: "100%", minHeight: "600px", border: "none", overflow: "hidden" }}
            scrolling="no"
            title="Book a consultation"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
